import { Observable } from 'rxjs';
import { CommonDataModel, ResponseFromServer } from '../../shared/_models';
import { RxDealsHttpClient } from '../../shared/_services/server-clients';
import { HttpOptions } from '../../shared/_services/http-client';
import { UniversalMediaList, UniversalMediaListDomainUpdatePayload, UniversalMediaListAssociatedDealsRemovalPayload } from './models';

export class UniversalMediaListsApiService {
  constructor(private readonly rxDealsHttpClient: RxDealsHttpClient) {}

  getUniversalMediaLists(filters: string): Observable<CommonDataModel<UniversalMediaList[]>> {
    return this.rxDealsHttpClient.getExpanded<UniversalMediaList[]>(`universal-media-lists?${filters}`);
  }

  getUniversalMediaList(id: number, filters: string): Observable<ResponseFromServer<UniversalMediaList>> {
    return this.rxDealsHttpClient.get<UniversalMediaList>(`universal-media-lists/${id}?${filters}`);
  }

  createUniversalMediaList(payload: UniversalMediaList): Observable<ResponseFromServer<UniversalMediaList>> {
    return this.rxDealsHttpClient.post<UniversalMediaList, UniversalMediaList>('universal-media-lists', payload);
  }

  updateUniversalMediaList(id: number, payload: UniversalMediaList): Observable<ResponseFromServer<UniversalMediaList>> {
    return this.rxDealsHttpClient.put<UniversalMediaList, UniversalMediaList>(`universal-media-lists/${id}`, payload);
  }

  deleteUniversalMediaList(id: number): Observable<ResponseFromServer<void>> {
    return this.rxDealsHttpClient.delete<void>(`universal-media-lists/${id}`);
  }

  restoreUniversalMediaList(id: number): Observable<ResponseFromServer<void>> {
    return this.rxDealsHttpClient.put<void, Record<string, never>>(`universal-media-lists/${id}/restore`, {});
  }

  duplicateUniversalMediaList(id: number): Observable<ResponseFromServer<UniversalMediaList>> {
    return this.rxDealsHttpClient.post<UniversalMediaList, Record<string, never>>(`universal-media-lists/${id}/duplicate`, {});
  }

  getUniversalMediaListDomains(id: number, filters: string): Observable<CommonDataModel<string[]>> {
    return this.rxDealsHttpClient.getExpanded<string[]>(`universal-media-lists/${id}/domains?${filters}`);
  }

  updateUniversalMediaListDomains(id: number, payload: UniversalMediaListDomainUpdatePayload): Observable<ResponseFromServer<void>> {
    return this.rxDealsHttpClient.put<void, UniversalMediaListDomainUpdatePayload>(`universal-media-lists/${id}/domains`, payload);
  }

  deleteUniversalMediaListAssociatedDeals(
    id: number,
    payload: UniversalMediaListAssociatedDealsRemovalPayload
  ): Observable<ResponseFromServer<UniversalMediaList>> {
    const httpOptions: HttpOptions = { body: payload };
    return this.rxDealsHttpClient.delete<UniversalMediaList>(`universal-media-lists/${id}/associated-deals`, httpOptions);
  }

  downloadUniversalMediaListDomains(id: number): Observable<ResponseFromServer<void>> {
    const httpOptions: HttpOptions = {
      responseType: 'text',
      headers: {
        'use-server-filename': 'true',
        'download-file': 'true',
      },
    };
    return this.rxDealsHttpClient.get<void>(`universal-media-lists/${id}/domains/csv-download`, httpOptions);
  }

  assignUniversalMediaListToDeal(payload: object): Observable<ResponseFromServer<object>> {
    return this.rxDealsHttpClient.post<object, object>('universal-media-lists/assign-to-deal', payload);
  }
}
